import React from 'react'

function StopIcon(props) {
	return (
		<svg width="17" height="23" viewBox="0 0 17 14" fill="#CA3568" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5A1.5 1.5 0 0 1 5 3.5z" />
		</svg>
	)
}

export default StopIcon
